import api from './default'

export default api('/api/schedule', 'schedules')
